// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"380":"0e301eb0422bc054bd1f","652":"52f2a113f4b8934ac72c"}[chunkId] + ".js";
};